import type { EmailStyleSettings } from "../../style-settings";
import { EMAIL_TOKENS } from "../../styles/tokens";
import { applyBlockStyles } from "../shared-block-styles";

import { CSSProperties } from "react";

/**
 * A paragraph's appearance, for the canvas and for the inbox alike.
 *
 * These used to be two answers to one question: the canvas set `margin: 0` and
 * let the composer's ambient CSS supply the type, while the send renderer
 * spelled out the tokens. They agreed by coincidence, and a change to either
 * side moved the composer away from what the recipient sees.
 */
export function getParagraphStyles(
  attrs: Record<string, unknown>,
  settings?: Partial<EmailStyleSettings>,
): CSSProperties {
  const styles: CSSProperties = {
    fontSize: settings?.fontSize || EMAIL_TOKENS.fontSize.sm,
    lineHeight: EMAIL_TOKENS.lineHeight.normal,
    color: EMAIL_TOKENS.colors.text.primary,
    ...(attrs.textAlign
      ? { textAlign: attrs.textAlign as CSSProperties["textAlign"] }
      : {}),
    margin: "0",
    padding: "0",
    position: "relative" as const,
    ...(settings?.fontFamily ? { fontFamily: settings.fontFamily } : {}),
  };
  applyBlockStyles(styles, attrs);
  return styles;
}
